// For Firebase JS SDK v7.20.0 and later, measurementId is optional

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore'




const firebaseConfig = {
    apiKey: "AIzaSyBp5IKLUq2pP3RrM-2tbsVPvdr7X41lREg",
    authDomain: "clone-28cfc.firebaseapp.com",
    projectId: "clone-28cfc",
    storageBucket: "clone-28cfc.appspot.com",
    messagingSenderId: "827267235003",
    appId: "1:827267235003:web:a84e1cee7fe2c4c623bd9e",
    measurementId: "G-3BSBT0B1SQ"
  };

  
  const firebaseApp = firebase.initializeApp(firebaseConfig);

  const db = firebaseApp.firestore()
  const auth = firebase.auth()

 export {db, auth}